'use strict';

const Constants = require('../constants/AppConstants');
const ChronologycServiceCache = require('../services/ChronologycServiceCache');

const NoteSchedule = {

    /**
     * Add new brewing note operation.
     * @param {Object} note
     */
    addBrewingNote: function (note) {
        ChronologycServiceCache.addBrewingOperation({
            typeOperation: Constants.NOTE_BREWING_OPERATION_NEW,
            note: note
        });
    },

    /**
     * Change brewing note operation.
     * @param {Object} note
     */
    changeBrewingNote: function (note) {
        ChronologycServiceCache.addBrewingOperation({
            typeOperation: Constants.NOTE_BREWING_OPERATION_CHANGE,
            note: note
        });
    },

    /**
     * Remove brewing note operation.
     * @param {Object} note
     */
    removeBrewingNote: function (note) {
        ChronologycServiceCache.addBrewingOperation({
            typeOperation: Constants.NOTE_BREWING_OPERATION_DELETE,
            note: note
        });
    },

    /**
     * Add new packaging note operation.
     * @param {Object} note
     */
    addPackagingNote: function (note) {
        ChronologycServiceCache.addPackagingOperation({
            typeOperation: Constants.NOTE_PACKAGING_OPERATION_NEW,
            note: note
        });
    },

    /**
     * Change packaging note operation.
     * @param {Object} note
     */
    changePackagingNote: function (note) {
        ChronologycServiceCache.addPackagingOperation({
            typeOperation: Constants.NOTE_PACKAGING_OPERATION_CHANGE,
            note: note
        });
    },

    /**
     * Remove packaging note operation.
     * @param {Object} note
     */
    removePackagingNote: function (note) {
        ChronologycServiceCache.addPackagingOperation({
            typeOperation: Constants.NOTE_PACKAGING_OPERATION_DELETE,
            note: note
        });
    }
};

module.exports = NoteSchedule;



/** WEBPACK FOOTER **
 ** ./src/pollers/NoteSchedule.js
 **/